function imageGallery() {
    let  imageIds = document.querySelectorAll("[id^='enap-gallery-']");
    if(imageIds.length>0){
       let my_awesome_script = document.createElement('script');
      my_awesome_script.setAttribute('src','https://enormapps.com/gallery-v2/assets/frontend/js/embed.js');
      document.head.appendChild(my_awesome_script);
    }

   let  videoIds = document.querySelectorAll("[id^='enap-video-']");
    if(videoIds.length>0){
      let my_awesome_script = document.createElement('script');
      my_awesome_script.setAttribute('src','https://enormapps.com/gallery-v2/assets/frontend/js/enap-video.js');
      document.head.appendChild(my_awesome_script);
    }
    
}
// document.addEventListener("DOMContentLoaded", imageGallery);
imageGallery()